import styled from 'styled-components';
import { useMapStore, useUserRolePermissionStore } from 'contexts/RootStore.context';
import { ChangeEvent, useEffect } from 'react';
import { observer } from 'mobx-react';
import { CheckBox } from 'components/inputs/CheckBox/CheckBox';
import { Horizontal } from 'gls';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #ffffff;
  height: 73px;
  width: 100%;
  padding: 25px;
  > span {
    margin-right: 9px;
  }
  .ant-checkbox-wrapper {
    &:nth-of-type(2) {
      margin-left: 12px;
    }
  }
`;

export const DisplaySetting = observer(() => {
  const { filterForm } = useMapStore()
  const assetsSearchSelected = filterForm.$.searchIn.value !== 'users';
  const usersSearchSelected = filterForm.$.searchIn.value !== 'assets';
  const { canViewUsers, canViewAssets } = useUserRolePermissionStore()

  function handleAssetMarkerInfoCheckboxToggle(ev: ChangeEvent<HTMLInputElement>) {
    const checked = ev.target.checked;
    filterForm.$.displayAssetName.onChange(checked)
  }

  function handleUsersMarkerInfoCheckboxToggle(ev: ChangeEvent<HTMLInputElement>) {
    const checked = ev.target.checked;
    filterForm.$.displayUserName.onChange(checked)
  }

  const showAssets = filterForm.$.show.value.includes("assets")
  const showUsers = filterForm.$.show.value.includes("users")

  useEffect(() => {
    // set marker infochecked to false, whenever show assets or users is false.
    // this will ensure infoboxes are not displayed initially when show markers are toggled off, then on.
    if (!showAssets || !assetsSearchSelected) {
      filterForm.$.displayAssetName.onChange(false)
    }
    if (!showUsers || !usersSearchSelected) {
      filterForm.$.displayUserName.onChange(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assetsSearchSelected, showAssets, showUsers, usersSearchSelected]);

  return (
    <StyledDiv data-test-id="display-checkbox">
      <Horizontal>
        <span>Display:</span>
        {canViewAssets && showAssets && assetsSearchSelected && (
          <CheckBox
            value={1}
            name='show-asset-name-checkbox'
            id="show-asset-name-checkbox"
            checked={filterForm.$.displayAssetName.value}
            onChange={handleAssetMarkerInfoCheckboxToggle}
            label='Asset Name & Asset Type'
          />
        )}
        {canViewUsers && showUsers && usersSearchSelected && (
          <CheckBox
            value={2}
            id="show-username-checkbox"
            name="show-username-checkbox"
            checked={filterForm.$.displayUserName.value}
            onChange={handleUsersMarkerInfoCheckboxToggle}
            label='Name'
          />
        )}
      </Horizontal>
    </StyledDiv>
  );
})